export { default } from './Bondiatv';
